/* eslint-disable eqeqeq,no-param-reassign,@typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').directive('designer', [
    '$rootScope',
    'Designer',

    function ($rootScope, Designer) {
      return {
        templateNamespace: 'html',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer.html'),
        replace: true,
        scope: {
          package: '=ngModel',
          designer: '=',
          width: '=',
          height: '=',
        },
        link(scope, element, attrs) {
          scope.designer.setElement(element);

          scope.$on(DESIGNER_EVENTS.RESIZE, function (event, size) {
            scope.designer.setSize(size);
            scope.designer.package.setSize();
          });

          scope.$watch('package', function (_package) {
            scope.designer.package.setData(_package);
            scope.designer.package.setSize();
            scope.designer.package.isFirstLoad = false;
            scope.designer.history.save('Package loaded');
          });

          if (scope.width && scope.height) {
            scope.designer.setSize({
              width: scope.width,
              height: scope.height,
            });
          }

          $rootScope.$broadcast(DESIGNER_EVENTS.CREATED, scope.designer);

          element.addClass('in');
        },
        controller: [
          '$scope',
          function ($scope) {
            $scope.designer = new Designer($scope.package);

            $scope.showPackageView = localStorage.getItem('package-preview') == 'true';
          },
        ],
      };
    },
  ]);
})(window.angular);
